import React from 'react';
import { RecurringConfig } from '../../types/recurringTypes';

interface RecurringBadgeProps {
    recurring?: RecurringConfig;
    yearNumber?: number;
    className?: string;
    compact?: boolean;
}

/**
 * Badge showing recurring event status with optional year number
 */
const RecurringBadge: React.FC<RecurringBadgeProps> = ({
    recurring,
    yearNumber,
    className = '',
    compact = false,
}) => {
    if (!recurring?.enabled) {
        return null;
    }

    const calendarIcon = recurring.calendarType === 'lunar' ? '🌙' : '☀️';

    if (compact) {
        return (
            <span
                className={`inline-flex items-center gap-0.5 text-xs ${className}`}
                title={`Lặp lại ${recurring.calendarType === 'lunar' ? 'âm lịch' : 'dương lịch'}`}
            >
                <span className="text-blue-400">🔄</span>
                <span>{calendarIcon}</span>
            </span>
        );
    }

    return (
        <div
            className={`
                inline-flex items-center gap-1.5 px-2 py-0.5 
                rounded-full bg-blue-500/20 text-blue-300
                text-xs font-medium
                ${className}
            `}
        >
            <span>🔄</span>
            <span>{calendarIcon}</span>
            {yearNumber && yearNumber > 0 && (
                <span className="text-yellow-300">
                    Năm thứ {yearNumber}
                </span>
            )}
        </div>
    );
};

export default RecurringBadge;
